import {Divider} from "@material-ui/core";
import React, {useEffect} from "react";
import {useNavigate} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../features/store";
import {getAuth} from "../features/sliceReducer/authReducer";

const withAuth = (
  WrappedComponent: React.ComponentType,
  option: boolean,
  adminRoute = null
) => {
  const WithAuth = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {isAuth} = useSelector((state: RootState) => state.auth);

    //null 아무나 출입이 가능한 페이지
    //true 로그인한 유저만 출입이 가능한 페이지
    //false 로그인한 유저는 출입 불가능한 페이지
    //adminRoute = true 이면 관리자만 출입가능

    useEffect(() => {
      if (!isAuth) {
        if (option) {
          navigate("/login");
        }
      } else {
        if (option) {
          // navigate("/inspect");
        } else {
          navigate("/inspect");
        }
      }
    }, [isAuth]);

    return <WrappedComponent />;
  };

  return <WithAuth />;
};

export default withAuth;
